import { createContext } from 'react';

export const TooltipContext = createContext({
  openId: null,
  setOpenId: () => {}
});
